<template>
  <div class="nes-container is-rounded">
    <h3>Welcome!</h3>
    <p>Use this site to generate your lineup and labels for each meet.</p>
    <div class="wrapper">
      <div>
        <h4>Meet Setup</h4>
        <label for="default_select">Select Age Group</label>
        <div class="nes-select" :class="{'is-error': isError.ageGroup }">
          <select @change="isError.ageGroup = false;" v-model="meetParams.ageGroup">
            <option value="" selected>Select...</option>
            <option value="prek">PreK/K/1st</option>
            <option value="2nd3rd">2nd/3rd/4th</option>
            <option value="4th6th">5th/6th</option>
          </select>
        </div>
        <label for="name_field">Meet Name</label>
        <div class="nes-select" :class="{'is-error': isError.meetName }">    
          <select @change="isError.meetName = false;" v-model="meetParams.meetName">
            <option value="" selected>Select...</option>
            <option value="Meet 1">Meet 1</option>
            <option value="Meet 2">Meet 2</option>
            <option value="Meet 3">Meet 3</option>
            <option value="Meet 4">Meet 4</option>
            <option value="Meet 5">Meet 5</option>
          </select>          
        </div>
        <div class="nes-field">
          <label for="name_field">Team Name</label>
          <input @change="isError.teamName = false;" v-model="meetParams.teamName" type="text" class="nes-input" :class="{'is-error': isError.teamName }">
        </div>        
        <div class="nes-field">
          <label for="name_field">Date</label>
          <input @change="isError.meetDate = false;" v-model="meetParams.meetDate" type="text" class="nes-input" :class="{'is-error': isError.meetDate }">
        </div>
        <div class="nes-field">
          <label for="name_field">Individual/Relay Lane</label>
          <input @change="isError.individualLane = false;" v-model="meetParams.individualLane" type="text" class="nes-input" :class="{'is-error': isError.individualLane }">
        </div>
        <div class="nes-field">
          <label for="name_field">Shuttle/Hurdle Lane</label>
          <input @change="isError.shuttleLane = false;" v-model="meetParams.shuttleLane" type="text" class="nes-input" :class="{'is-error': isError.shuttleLane }">
        </div>
      </div>
      <div class="roster">
        <!-- <button type="button" @click="showRunnerDialog" class="nes-btn add-button">Add</button> -->
        <button type="button" @click="clearRoster" class="nes-btn is-error add-button">Clear</button>
        <h4 class="roster-heading">Roster</h4>
        <div class="nes-container with-title is-rounded roster-list">
            <p class="title">
              <span class="nes-text" :class="{'is-error': isError.girlsRoster }">Girls</span>
            </p>
            <div v-for="(runner, index) in roster.girls" :key="runner.name">
              <button @click="clearRunner('girls',index)" type="button" class="nes-btn is-error heat-clear">X</button>
              <span>{{runner.name}}</span>
            </div>
            <div class="nes-field is-inline">
              <input placeholder="Add Girl" v-model="newGirlRunner" type="text" class="nes-input" @keyup.enter="addRunner('F')">
              <label for="name_field"><button @click="addRunner('F')" type="button" class="nes-btn is-success">+</button></label>
            </div>
          </div>
          <div class="nes-container with-title is-rounded roster-list" :class="{'is-error': isError.boysRoster }">
            <p class="title">
              <span class="nes-text" :class="{'is-error': isError.boysRoster }">Boys</span>
            </p> 
            <div v-for="(runner, index) in roster.boys" :key="runner.name">
              <button @click="clearRunner('boys', index)" type="button" class="nes-btn is-error heat-clear">X</button>
              <span>{{runner.name}}</span>
            </div>
            <div class="nes-field is-inline">
              
              <input placeholder="Add Boy" v-model="newBoyRunner" type="text" class="nes-input" @keyup.enter="addRunner('M')">
              <label for="name_field"><button @click="addRunner('M')" type="button" class="nes-btn is-success">+</button></label>
            </div>
          </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" @click="submit" class="nes-btn is-primary submit-button">Submit</button>
    </div>
    <dialog class="nes-dialog is-rounded" ref="errorDialog">
        <p class="title">Errors</p>
        
        <menu class="dialog-menu">
          <button @click="closeDialog" class="nes-btn">Close</button>
        </menu>
    </dialog>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data () {
    return {
      meetParams: {
        ageGroup:'',
        meetName:'',
        teamName:'',
        meetDate:'',
        individualLane:'',
        shuttleLane:''
      },
      roster:{
        girls:[],
        boys:[]
      },
      newBoyRunner: '',
      newGirlRunner:'',
      newRunnerName: '',
      newRunnerGender: '',
      isError: {
        ageGroup:false,
        meetName:false,
        teamName:false,
        meetDate:false,
        individualLane:false,
        shuttleLane:false,
        boysRoster:false,
        girlsRoster:false
      }
    }
  },
  methods: {
    showErrorDialog () {
      this.$refs.errorDialog.showModal();
    },
    closeDialog() {
      this.$refs.errorDialog.close();
      this.newRunnerGender = '';
      this.newRunnerName = '';
    },
    addRunner (gender) {
      if(gender === 'F' && this.newGirlRunner.length > 0) {
        this.isError.girlsRoster = false;
        this.roster.girls.push({name:this.newGirlRunner, gender, num_events:0});
        this.newGirlRunner = '';
      }
      else if(gender === 'M' && this.newBoyRunner.length > 0) {
        this.isError.boysRoster = false;
        this.roster.boys.push({name:this.newBoyRunner, gender, num_events:0});
        this.newBoyRunner = '';
      }
      // this.newRunnerGender = '';
      // this.newRunnerName = '';
      // this.$refs.runnerDialog.close();
    },
    clearRunner(gender, index) {
      this.roster[gender].splice(index, 1);
    },
    clearRoster() {
      this.roster = {
        girls:[],
        boys:[]
      };
      window.localStorage.removeItem('roster');
    },
    submit () {
     
      //validate input
      let isValid = true;
      for(let param in this.meetParams) {
        if(!this.meetParams[param]) {
          this.isError[param] = true;
          isValid = false;
        }
      }
      if(this.roster.girls.length < 1) {
        this.isError.girlsRoster = true;
        isValid = false;
      }
      if(this.roster.boys.length < 1) {
        this.isError.boysRoster = true;
        isValid = false;
      }
      if(isValid) {
        this.$store.commit('setMeetParams', this.meetParams);
        this.$store.commit('setNewRoster', this.roster);
        window.localStorage.setItem('roster', JSON.stringify(this.roster));
        this.$router.push('/meet');
      }

    }
  },
  mounted () {
    let savedRoster = window.localStorage.getItem('roster');
    if(savedRoster) {
      this.roster = JSON.parse(savedRoster);
    }
  },
  components: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .buttons {
    height:40px;
  }
  .submit-button {
    float: right;
  }
  .add-button {
    float:right;
  }
  .roster {
    padding-left: 35px;
  }
  .roster-heading {
    padding-bottom: 36px;
  }
  .heat-clear {
      float:right;
      font-size: .4em;
      margin: 0;
      padding: 3px 4px;
    }
</style>
